import { Navigate, useParams, useRoutes } from "react-router-dom";

import AdminAccountRoutes from "./account/routes";
import ArticlePage from "./article";
import PlatformRoutes from "./platform/routes";
import ProductPage from "./product";
import UserPage from "./user";
import VendorPage from "./vendor";

export default () =>
  useRoutes([
    { path: "/article/:id", element: <WithParameters component={ArticlePage}/> },
    { path: "/article", element: <WithParameters component={ArticlePage}/> },
    { path: "/product/:id", element: <WithParameters component={ProductPage}/> },
    { path: "/product", element: <WithParameters component={ProductPage}/> },
    { path: "/vendor/:id", element: <WithParameters component={VendorPage}/> },
    { path: "/vendor", element: <WithParameters component={VendorPage}/> },
    { path: "/user", element: <UserPage/> },
    { path: "/platform/*", element: <PlatformRoutes/> },
    { path: "/account/*", element: <AdminAccountRoutes/> },
    { path: "/", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
